<template>
  <div>
    <ed-modal
      :title="(this.$store.state.ltcat.title+' Novo GHE')"
      :modal="showFormEdit"
      :loadingSave="config.loading.save"
      :onClose="onClose"
      :onSave="(tagConfig == 'tab-cadastro' ? this.salvar : null)"
      width="98%"
    >
      <div slot="modal-content" v-loading="config.loading.content">
        <el-tabs type="card" v-model="tagConfig">
          <el-tab-pane label="Config" name="tab-cadastro">
            <span slot="label">
              <i class="fa fa-list-alt"></i> Informações do GHE
            </span>

            <ed-form :data="formData" :config="config" :response="response" :itens="formItems">
              <div slot="form-footer">
                <div class="mb-2 text-left">
                  <ed-button
                    icon="fa fa-plus-circle"
                    type="text"
                    @click="onRegister"
                    value="Inserir Nova Linha"
                  />
                  <b-table
                    class="table-v2"
                    striped
                    hover
                    bordered
                    small
                    show-empty
                    sort-icon-left
                    responsive
                    head-variant="light"
                    empty-text="Nenhum item encontrado"
                    :busy="config.loading.content || config.loading.copiar"
                    :items="tableData"
                    :fields="tableHead"
                    :stacked="(this.device == 'xs')"
                  >
                    <!--FORMATAR CABEÇALHO-->
                    <template v-slot:head()="data">
                      <span style="font-size:7pt">{{ data.label.toUpperCase() }}</span>
                    </template>

                    <!--STYLE TABLE-->
                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"
                        :key="field.key"
                        :style="{ width: field.width }"
                      />
                    </template>

                    <!--FORMATAR COLUNAS-->
                    <template v-slot:cell()="data">
                      <el-input
                        @change="formatData"
                        v-if="data.field && data.field.show_text"
                        v-model="data.item._data[data.field.key]"
                        :maxlength="150"
                        :disabled="data.item._data.ativo == 0"
                        type="text"
                      />

                      <el-input-number
                        @change="formatData"
                        v-else-if="data.field && data.field.show_numeric"
                        v-model="data.item._data[data.field.key]"
                        :disabled="data.item._data.ativo == 0"
                        :min="0"
                      />
                    </template>

                    <template v-slot:cell(buttons)="data">
                      <div class="text-centers">
                        <ed-button
                          icon="fa fa-trash"
                          type="danger"
                          size="mini"
                          title="Deletar Registro"
                          @click="onDelete(data)"
                        />
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </ed-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </ed-modal>
  </div>
</template>

<script>
import Rest from "common/rest";
import EdForm from "common/form";
import EdModal from "common/modal";
import EdButton from "common/button";
import FormItems from "./_form/ltcat-ghe-cadastrar";
import Funcao from "./funcao";
import Medicao from "./medicao";
import ConclusaoTecnica from "./conclusao-tecnica";

export default {
  name: "empresa",
  components: { EdForm, EdModal, Funcao, EdButton, Medicao, ConclusaoTecnica },
  mixins: [Rest],
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.showFormCadastro"() {
      this.showFormEdit = !this.showFormEdit;
      this.inicialize();
    },
    "$store.state.ltcat.data.id"() {
      this.inicialize();
    }
  },
  data() {
    return {
      config: {
        click: {
          copiar: this.getGhe
        },
        loading: {
          save: false,
          config: false,
          copiar: false,
          content: false
        },
        list: {
          copiar: []
        }
      },
      response: {},
      formItems: [],
      formData: {
        id: 0,
        copiar: null,
        ghes: []
      },
      tagConfig: "tab-cadastro",
      title: null,
      showFormEdit: false,
      tableHead: [
        {
          key: "ordem",
          show_numeric: true,
          sortable: true,
          width: "200px",
          label: "Ordem"
        },
        {
          key: "ghe",
          show_text: true,
          sortable: true,
          width: "200px",
          label: "GHE"
        },
        {
          key: "descricao",
          show_text: true,
          sortable: true,
          label: "Descrição"
        },
        {
          key: "buttons",
          label: "",
          width: "50px"
        }
      ],
      tableData: []
    };
  },

  created() {},

  mounted: function() {
    this.formItems = FormItems;
  },
  methods: {
    inicialize(formData) {
      this.formData = Object.assign(
        {},
        formData ? formData : this.parent.formData
      );

      this.tagConfig = "tab-cadastro";
      this.tableData = [];
      this.getGhe();
    },

    onRegister() {
      var 
        ordem = this.tableData.length + 1,
        ghe = this.tableData.length + 1;

      if (this.tableData.length == 0 && this.config.list.copiar.length > 0) {
        var _data = this.config.list.copiar[this.config.list.copiar.length - 1];

        ordem = _data.ordem + 1;
        ghe = _data.ordem + 1;
      } else {
        var _data = this.tableData[this.tableData.length - 1];

        if(_data){
          ordem = _data.ordem + 1;
          ghe = _data.ordem + 1;
        }
        else{
          ordem = 1;
          ghe =  1;
        }
      }

      var data = {
        id: 0,
        ordem: ordem,
        ghe: ghe,
        descricao: null
      };

      this.tableData.push({
        id: 0,
        ordem: data.ordem,
        ghe: data.ghe,
        descricao: null,
        _data: data
      });
    },

    onDelete(item) {
      this.tableData.splice(item.index, 1);
    },

    onClose() {
      this.parent.getLtcat();
    },

    getGhe(_search) {
      this.config.loading.copiar = true;
      this.config.list.copiar = [];

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search
      }).then(result => {
        result = result[0];
        this.config.loading.copiar = false;

        if (result.status == 200) {
          this.config.list.copiar = result.data.data;
        }

        if (this.tableData.length == 0) this.onRegister();
      });
    },

    formatData() {
      this.formData.ghes = [];

      for (let i = 0; i < this.tableData.length; i++) {
        const element = this.tableData[i];
        this.formData.ghes.push(element._data);
      }
    },

    salvar() {
      this.formatData();

      this.config.loading.save = true;
      this.response = {};

      this.post(
        "/ltcat/ghe/" + this.$store.state.ltcat.data.id + "/cadastrar",
        this.formData
      ).then(result => {
        result = result[0];

        this.config.loading.save = false;
        this.response = result;

        if (result.status == 200) {
          this.edMsg("Dados atualizados");
          this.showFormEdit = !this.showFormEdit;
          this.parent.getLtcat();
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// cadastrar.vue?2c421e52